/**
 * getUpsellUrlsConfigByEdition - Returns the proper edition adsConfig object from the external `app-configurations`
 * JSON; defaults to an empty object for easier destructuring.
 *
 * @param {string} edition - Top level app edition obtained from editionMapping
 * @param {object} adsConfig = {} - External adsConfig object supporting multiple editions
 *
 * @return {object} - Config object containing possible properties such as `profile`, `networkId` and `host`
 */
export default function getUpsellUrlsConfigByEdition(edition, urlsConfigMap = {}) {
    // catches null or undefined
    if (!edition || !urlsConfigMap) {
        return {};
    }

    if (urlsConfigMap[edition]) {
        return urlsConfigMap[edition];
    }

    if (edition === 'us' && urlsConfigMap.domestic) {
        return urlsConfigMap.domestic;
    }

    // no mapping found from external config object
    return {};
}



// WEBPACK FOOTER //
// ./app/lib/util/getUpsellUrlsConfigByEdition.js